// ----------------------------------------------------------------------

export default function Typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        // v9 removed the `paragraph` prop and its class from Typography, so an
        // override on that slot no longer matches anything. Nothing in src/ used
        // the prop, so this is dropped rather than remapped.
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
